<template>
  <div class="container">


    <div class="handle-box">
      <el-form :model="searchForm" ref="searchForm" inline label-width="100px">
        <el-form-item label="文件名：" prop="importFileName">
          <el-input size="small" v-model="searchForm.importFileName" clearable placeholder="请输入文件名"
                    style="width: 280px;"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
                     @click="handleSearch">搜索</el-button>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-plus"
                     @click="showAddDialog">添加销户</el-button>
          <el-tooltip content="下载批量销户模板" placement="top">
            <el-button size="small" :class="[theme]" icon="el-icon-download"
                       @click="downloadTemplate">模板下载</el-button>
          </el-tooltip>
        </el-form-item>

      </el-form>



    </div>

    <!-- 数据表格 -->
    <el-table :data="tableData" border class="table" ref="multipleTable" v-loading="loading"
              header-cell-class-name="table-header" :row-style="{ height: '20px' }"
              :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe>
      <el-table-column prop="importFileName" label="导入文件名" align="center" min-width="200" show-overflow-tooltip>
        <template #default="scope">
          <span class="file-name">{{ scope.row.importFileName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="operNo" label="操作工号" align="center" width="130"></el-table-column>
      <el-table-column prop="operName" label="操作人" align="center" width="130"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" width="160">
        <template #default="scope">
          <span>{{ formatDateTime(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="finishTime" label="完成时间" align="center" width="160">
        <template #default="scope">
          <span v-if="scope.row.finishTime">{{ formatDateTime(scope.row.finishTime) }}</span>
          <span v-else style="color: #909399;">处理中</span>
        </template>
      </el-table-column>
      <el-table-column prop="exportFileName" label="下载文件名" align="center" min-width="200" show-overflow-tooltip></el-table-column>
      <el-table-column prop="status" label="处理状态" align="center" width="100">
        <template #default="scope">
          <el-tag :type="getStatusType(scope.row)" size="small">
            {{ getStatusText(scope.row) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template #default="scope">
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-download"
                     @click="handleDownload(scope.row)" :loading="downloadLoading === scope.row.fileUrl">
            下载结果
          </el-button>

        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                     :current-page="pagination.pageIndex" :page-sizes="[10, 20, 50, 100]"
                     :page-size="pagination.pageSize" :total="pagination.total"
                     @size-change="handleSizeChange" @current-change="handlePageChange"></el-pagination>
    </div>

    <!-- 添加销户对话框 -->
    <el-dialog title="添加销户" v-model="addDialog.visible" width="600px" @close="closeAddDialog">
      <el-form :model="addDialog.form" ref="addForm" label-width="120px" :rules="addDialog.rules">
        <el-form-item label="选择模式：" prop="type">
          <el-radio-group v-model="addDialog.form.type" @change="handleModeChange">
            <el-radio label="1">手动输入</el-radio>
            <el-radio label="2">批量模板</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="销户原因：" prop="batchNo" required>
          <el-input size="small" type="textarea" :rows="3" v-model="addDialog.form.batchNo"
                    placeholder="请输入销户原因，必填" maxlength="200" show-word-limit></el-input>
        </el-form-item>

        <el-form-item :label="addDialog.form.type === '1' ? '手机号码：' : '上传文件：'"
                      :prop="addDialog.form.type === '1' ? 'phones' : 'file'" required>
          <template v-if="addDialog.form.type === '1'">
            <div class="input-area">
              <el-input size="small" type="textarea" :rows="6" v-model="addDialog.form.phones"
                        placeholder="一行一个手机号码，一次最多添加500个号码" @input="validatePhones"></el-input>
              <div class="input-tips">
                <span>已输入 {{ phoneCount }} 个号码</span>
                <span v-if="invalidPhoneCount > 0" style="color: #F56C6C; margin-left: 20px;">
                  {{ invalidPhoneCount }} 个无效号码
                </span>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="upload-area">
              <el-upload ref="uploadRef" action="/api/Snail/batchCancellation" :headers="uploadHeaders"
                         :limit="1" :on-success="handleUploadSuccess" :on-error="handleUploadError"
                         :on-change="handleFileChange" :auto-upload="false" :data="addDialog.form"
                         accept=".txt" :file-list="addDialog.fileList">
                <el-button size="small" type="primary" :class="[theme]">选择文件</el-button>
                <div slot="tip" class="el-upload__tip">
                  <div>只能上传txt文件，文件格式要求：</div>
                  <div>1. 一行一个手机号码</div>
                  <div>2. 最多500个号码</div>
                  <div>3. 文件大小不超过2MB</div>
                </div>
              </el-upload>
            </div>
          </template>
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button size="small" @click="closeAddDialog">取消</el-button>
        <el-button size="small" type="primary" :class="[theme]" @click="submitBatchCancellation"
                   :loading="addDialog.loading" :disabled="!isFormValid">
          {{ addDialog.form.type === '1' ? '提交销户' : '上传文件' }}
        </el-button>
      </template>
    </el-dialog>

    <!-- 处理详情对话框 -->
    <el-dialog title="处理详情" v-model="detailDialog.visible" width="800px">
      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="文件名">{{ detailDialog.data.importFileName }}</el-descriptions-item>
        <el-descriptions-item label="操作工号">{{ detailDialog.data.operNo }}</el-descriptions-item>
        <el-descriptions-item label="操作人">{{ detailDialog.data.operName }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatDateTime(detailDialog.data.createTime) }}</el-descriptions-item>
        <el-descriptions-item label="完成时间">{{ formatDateTime(detailDialog.data.finishTime) }}</el-descriptions-item>
        <el-descriptions-item label="下载文件名">{{ detailDialog.data.exportFileName }}</el-descriptions-item>
        <el-descriptions-item label="文件URL" :span="2">
          <a :href="detailDialog.data.fileUrl" target="_blank" style="color: #409EFF;">
            {{ detailDialog.data.fileUrl }}
          </a>
        </el-descriptions-item>
      </el-descriptions>

      <template #footer>
        <el-button @click="detailDialog.visible = false">关闭</el-button>
        <el-button type="primary" @click="handleDownload(detailDialog.data)">下载结果</el-button>
      </template>
    </el-dialog>

    <!-- 结果反馈对话框 -->
    <el-dialog :title="resultDialog.title" v-model="resultDialog.visible" width="500px">
      <div class="result-content">
        <div class="result-icon" :class="resultDialog.type">
          <el-icon :size="60">
            <component :is="resultDialog.icon" />
          </el-icon>
        </div>
        <div class="result-message">{{ resultDialog.message }}</div>
        <div v-if="resultDialog.details" class="result-details">
          <el-alert :title="resultDialog.detailsTitle" :type="resultDialog.type" :closable="false">
            <pre>{{ resultDialog.details }}</pre>
          </el-alert>
        </div>
      </div>

      <template #footer>
        <el-button @click="resultDialog.visible = false">关闭</el-button>
        <el-button v-if="resultDialog.downloadUrl" type="primary" @click="downloadResultFile">
          下载结果文件
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getBatchCancellation, batchCancellation, fastdfsfile } from '../api/dijia.js';

export default {
  name: 'BatchAccountClosure',
  data() {
    // 手机号码验证规则
    const validatePhones = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        callback(new Error('请输入手机号码'));
        return;
      }

      const phones = value.split('\n').filter(phone => phone.trim());
      if (phones.length === 0) {
        callback(new Error('请输入有效的手机号码'));
        return;
      }

      if (phones.length > 500) {
        callback(new Error('一次最多添加500个号码'));
        return;
      }

      // 验证手机号码格式
      const invalidPhones = phones.filter(phone => {
        const trimmed = phone.trim();
        return !/^1[3-9]\d{9}$/.test(trimmed);
      });

      if (invalidPhones.length > 0) {
        callback(new Error(`有${invalidPhones.length}个无效的手机号码格式`));
      } else {
        callback();
      }
    };

    return {
      theme: localStorage.getItem('theme'),
      loading: false,
      downloadLoading: null,

      // 搜索表单
      searchForm: {
        importFileName: '',
        dateRange: []
      },

      // 分页
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },

      // 表格数据
      tableData: [],

      // 添加对话框
      addDialog: {
        visible: false,
        loading: false,
        form: {
          type: '1',
          phones: '',
          batchNo: '',
          userId: localStorage.getItem('user'),
        },
        fileList: [],
        rules: {
          // batchNo: [
          //   { required: true, message: '请输入销户原因', trigger: 'blur' },
          //   { min: 5, message: '销户原因至少5个字符', trigger: 'blur' }
          // ],
          phones: [
            { validator: validatePhones, trigger: 'blur' }
          ],
          file: [
            { required: true, message: '请选择上传文件', trigger: 'change' }
          ]
        }
      },

      // 详情对话框
      detailDialog: {
        visible: false,
        data: {}
      },

      // 结果对话框
      resultDialog: {
        visible: false,
        title: '',
        type: 'success',
        icon: 'CircleCheck',
        message: '',
        details: '',
        detailsTitle: '',
        downloadUrl: ''
      },

      // 上传相关
      uploadHeaders: {
        Authorization: localStorage.getItem('token'),
        type: 'web',
        UserRole: localStorage.getItem('ms_role'),
        XSecurityVersion: 'v2',
      },

      // 统计信息
      phoneCount: 0,
      invalidPhoneCount: 0
    };
  },
  computed: {
    isFormValid() {
      if (!this.addDialog.form.batchNo || this.addDialog.form.batchNo.trim() === '') {
        return false;
      }

      if (this.addDialog.form.type === '1') {
        return this.addDialog.form.phones && this.addDialog.form.phones.trim() !== '' && this.phoneCount > 0 && this.invalidPhoneCount === 0;
      } else {
        return this.addDialog.fileList.length > 0;
      }
    }
  },
  created() {
    this.getBatchCancellations();
  },
  methods: {
    // 格式化日期时间
    formatDateTime(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      if (isNaN(date.getTime())) return '';

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 获取状态类型
    getStatusType(row) {
      if (!row.finishTime) return 'warning'; // 处理中
      return 'success'; // 已完成
    },

    // 获取状态文本
    getStatusText(row) {
      if (!row.finishTime) return '处理中';
      return '已完成';
    },

    // 搜索处理
    handleSearch() {
      this.pagination.pageIndex = 1;
      this.getBatchCancellations();
    },

    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.dateRange = [];
      this.pagination.pageIndex = 1;
      this.getBatchCancellations();
    },

    // 获取销户记录列表
    async getBatchCancellations() {
      try {
        this.loading = true;

        const params = {
          ...this.searchForm,
          pageIndex: this.pagination.pageIndex,
          pageSize: this.pagination.pageSize,
          userId: localStorage.getItem('user')
        };

        // 处理时间范围
        if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
          params.startTime = this.convertDateStringToTimestamp(this.formatDate(this.searchForm.dateRange[0]));
          params.endTime = this.convertDateStringToTimestamp(this.formatDate(this.searchForm.dateRange[1])) + 86399000;
        }

        const res = await getBatchCancellation(params);

        if (res?.code === 200) {
          this.tableData = res.data.list || [];
          this.pagination.total = res.data.total || 0;
        } else {
          this.$message.error(res?.message || '获取数据失败');
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (error) {
        console.error('获取销户记录失败:', error);
        this.$message.error('获取销户记录失败');
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 显示添加对话框
    showAddDialog() {
      this.addDialog.visible = true;
      this.addDialog.form = {
        type: '1',
        phones: '',
        batchNo: '',
        userId: localStorage.getItem('user'),
      };
      this.addDialog.fileList = [];
      this.phoneCount = 0;
      this.invalidPhoneCount = 0;

      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles();
      }
    },

    // 关闭添加对话框
    closeAddDialog() {
      this.addDialog.visible = false;
      this.addDialog.loading = false;
      if (this.$refs.addForm) {
        this.$refs.addForm.clearValidate();
      }
    },

    // 处理模式变更
    handleModeChange() {
      this.addDialog.fileList = [];
      this.phoneCount = 0;
      this.invalidPhoneCount = 0;

      if (this.$refs.addForm) {
        this.$refs.addForm.clearValidate();
      }
    },

    // 验证手机号码
    validatePhones() {
      if (!this.addDialog.form.phones) {
        this.phoneCount = 0;
        this.invalidPhoneCount = 0;
        return;
      }

      const phones = this.addDialog.form.phones.split('\n').filter(phone => phone.trim());
      this.phoneCount = phones.length;

      this.invalidPhoneCount = phones.filter(phone => {
        const trimmed = phone.trim();
        return !/^1[3-9]\d{9}$/.test(trimmed);
      }).length;
    },

    // 处理文件变更
    handleFileChange(file, fileList) {
      this.addDialog.fileList = fileList;
    },

    // 提交批量销户
    async submitBatchCancellation() {
      try {
        // 表单验证
        if (this.addDialog.form.type === '1') {
          const validatePhones = (rule, value, callback) => {
            if (!value || value.trim() === '') {
              callback(new Error('请输入手机号码'));
              return;
            }
            const phones = value.split('\n').filter(phone => phone.trim());
            if (phones.length === 0) {
              callback(new Error('请输入有效的手机号码'));
              return;
            }
            if (phones.length > 500) {
              callback(new Error('一次最多添加500个号码'));
              return;
            }
          };
        } else {
          if (this.addDialog.fileList.length === 0) {
            this.$message.warning('请选择上传文件');
            return;
          }
        }

        if (!this.addDialog.form.batchNo || this.addDialog.form.batchNo.trim() === '') {
          this.$message.warning('请输入销户原因');
          return;
        }

        this.addDialog.loading = true;

        if (this.addDialog.form.type === '1') {
          // 手动输入模式
          await this.handleManualSubmit();
        } else {
          // 文件上传模式
          await this.handleFileUpload();
        }
      } catch (error) {
        console.error('提交销户失败:', error);
        this.showResult('error', '提交失败', '系统错误，请稍后重试');
      } finally {
        this.addDialog.loading = false;
      }
    },

    // 处理手动提交
    async handleManualSubmit() {
      const confirm = await this.$confirm(
          `确定要对 ${this.phoneCount} 个号码进行销户操作吗？<br/>原因：${this.addDialog.form.batchNo}`,
          '确认销户',
          {
            dangerouslyUseHTMLString: true,
            type: 'warning',
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }
      ).catch(() => false);

      if (!confirm) return;

      const data = {
        phones: this.addDialog.form.phones,
        type: this.addDialog.form.type,
        batchNo: this.addDialog.form.batchNo,
        userId: this.addDialog.form.userId,
      };

      const res = await batchCancellation(data);

      if (res?.code === 200) {
        this.showResult('success', '销户成功', '请下载结果文件查看详细处理情况', res.data, '处理结果文件');
        this.addDialog.visible = false;
        this.getBatchCancellations();
      } else {
        this.showResult('error', '销户失败', res?.message || '操作失败');
      }
    },

    // 处理文件上传
    async handleFileUpload() {
      this.$refs.uploadRef.submit();
    },

    // 上传成功处理
    handleUploadSuccess(response, file, fileList) {
      if (response?.code === 200) {
        this.showResult('success', '上传成功', '请下载结果文件查看详细处理情况', response.data, '处理结果文件');
        this.addDialog.visible = false;
        this.getBatchCancellations();
      } else {
        this.showResult('error', '上传失败', response?.message || '文件上传失败');
      }
    },

    // 上传错误处理
    handleUploadError(error, file, fileList) {
      console.error('文件上传失败:', error);
      this.showResult('error', '上传失败', '文件上传过程中发生错误');
    },

    // 下载处理结果
    async handleDownload(row) {
      try {
        this.downloadLoading = row.fileUrl;

        const data = {
          fileName: row.fileUrl,
          open: ''
        };

        const response = await fastdfsfile(data);

        // 创建Blob对象
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        // 创建下载链接
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = row.exportFileName || '销户记录.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // 释放URL对象
        URL.revokeObjectURL(url);

        this.$message.success('文件下载成功');
      } catch (error) {
        console.error('下载文件失败:', error);
        this.$message.error('下载文件失败');
      } finally {
        this.downloadLoading = null;
      }
    },

    // 显示详情
    showDetail(row) {
      this.detailDialog.visible = true;
      this.detailDialog.data = { ...row };
    },

    // 下载模板
    downloadTemplate() {
      const templateContent = `17012345678
17087654321
`;

      const blob = new Blob([templateContent], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = '批量销户模板.txt';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      this.$message.success('模板下载成功');
    },

    // 显示结果对话框
    showResult(type, title, message, downloadUrl = '', detailsTitle = '') {
      this.resultDialog = {
        visible: true,
        title,
        type,
        icon: type === 'success' ? 'CircleCheck' : 'CircleClose',
        message,
        downloadUrl,
        details: downloadUrl,
        detailsTitle
      };
    },

    // 下载结果文件
    async downloadResultFile() {
      if (!this.resultDialog.downloadUrl) return;

      try {
        const data = {
          fileName: this.resultDialog.downloadUrl,
          open: ''
        };

        const response = await fastdfsfile(data);

        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = '销户处理结果.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
        this.resultDialog.visible = false;

        this.$message.success('文件下载成功');
      } catch (error) {
        console.error('下载结果文件失败:', error);
        this.$message.error('下载结果文件失败');
      }
    },

    // 分页处理
    handlePageChange(val) {
      this.pagination.pageIndex = val;
      this.getBatchCancellations();
    },

    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.pageIndex = 1;
      this.getBatchCancellations();
    },

    // 工具函数
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    convertDateStringToTimestamp(dateString) {
      if (!dateString) return 0;
      const parts = dateString.split('-');
      if (parts.length < 3) return 0;
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const day = parseInt(parts[2], 10);
      const date = new Date(year, month, day);
      return date.getTime();
    }
  }
};
</script>

<style scoped>
.container {
  padding: 20px;
  background: #fff;
  min-height: calc(100vh - 84px);
  border-radius: 4px;
}

.header {
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}

.page-title {
  font-size: 20px;
  font-weight: bold;
  color: #303133;
  margin: 0 0 8px 0;
}

.page-subtitle {
  font-size: 14px;
  color: #909399;
}

.handle-box {
  margin-bottom: 20px;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 4px;
}

.action-buttons {
  margin-top: 15px;
  display: flex;
  gap: 10px;
}

.table {
  width: 100%;
  font-size: 14px;
  margin-top: 20px;
}

.file-name {
  color: #409EFF;
  cursor: pointer;
}

.file-name:hover {
  text-decoration: underline;
  color: #66b1ff;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.input-area, .upload-area {
  width: 100%;
}

.input-tips {
  margin-top: 8px;
  font-size: 12px;
  color: #606266;
}

.el-upload__tip {
  margin-top: 8px;
  font-size: 12px;
  color: #606266;
  line-height: 1.5;
}

.result-content {
  text-align: center;
  padding: 20px 0;
}

.result-icon {
  margin-bottom: 20px;
}

.result-icon.success {
  color: #67C23A;
}

.result-icon.error {
  color: #F56C6C;
}

.result-message {
  font-size: 16px;
  margin-bottom: 20px;
  color: #303133;
}

.result-details {
  margin-top: 20px;
}

.result-details pre {
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 12px;
  margin: 0;
  padding: 10px;
  background: #f6f8fa;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
}

:deep(.el-table__header-wrapper) {
  font-weight: bold;
}

:deep(.el-form-item__label) {
  font-weight: 500;
}

:deep(.el-dialog__body) {
  padding: 20px;
}

:deep(.el-descriptions__label) {
  width: 100px;
  font-weight: bold;
}
</style>